/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import ResumeGame from '@/components/home/modals/ResumeGame';
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Maintenance from '@/components/home/modals/shared/Maintenance';
import NoBalanceModal from '../../../components/home/modals/NoBalanceModal';
import RequestForRematch from '../extraRematchInfo';

const ChecksToStartNewGameWithCelebrity = {
  mixins: [RequestForRematch],
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    ...mapMutations('game', [
      'updateChallengeInfo',
    ]),
    checkGameValidationsForCelebrity() {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.storeModalForHomePage(Maintenance);
        } else {
          this.checkIfGameToResumeExists().then(() => {
            const activeIntegrationConfig = this.getActiveIntegrationConfig;
            if (this.gameInProgress) {
              this.storeModalForHomePage(ResumeGame);
            } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
              if (this.subAndUnsubViaSMS) {
                if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                  this.storeModalForHomePage(ResubscribeGameSms);
                } else {
                  this.storeModalForHomePage(ResubscribeGame);
                }
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
              this.storeModalForHomePage(ZeroBalance);
            } else if (activeIntegrationConfig && activeIntegrationConfig.hasNoBalance && this.userDetails.parked) {
              this.storeModalForHomePage(NoBalanceModal);
            } else {
              this.requestRematch(null, false, null, true);
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('common', [
      'getActiveIntegrationConfig',
    ]),
  },
};

export default ChecksToStartNewGameWithCelebrity;



// WEBPACK FOOTER //
// ./src/common/mixins/rematch/celebrityMatchValidations.js